import React from 'react'
import { styled } from '@mui/material/styles'
import { useTest } from '@hooks/useTest'
import { useBaseCollectionTileContext } from '../BaseCollectionTileContext'
import { determineIsOnSale } from '../helpers'
import Price from '../../../../@rtg2022/components/atoms/Price/Price'

const PriceRangeWrapper = styled('div')(({ theme, isOnSale }) => ({
  display: 'flex',
  gap: '4px',
  color: isOnSale ? theme.palette.error.main : '#07263B',
  fontWeight: 600,
  fontSize: '23px',
  lineHeight: 'normal',
  alignItems: 'center',
}))

const PriceText = styled('span')(() => ({
  fontSize: '16px',
  paddingTop: '4px',
}))

const PriceRange = () => {
  const { collection, priceZone } = useBaseCollectionTileContext()
  const { generateTestId } = useTest()
  const listMax = collection?.[`zone_${priceZone}_list_price_max`]
  const listMin = collection?.[`zone_${priceZone}_list_price_min`]
  const saleMax = collection?.[`zone_${priceZone}_sale_price_max`]
  const saleMin = collection?.[`zone_${priceZone}_sale_price_min`]

  if (!listMax || !listMin || !saleMax || !saleMin) {
    return null
  }

  const minPrice = saleMin || listMin
  const maxPrice = saleMax || listMax

  return (
    <PriceRangeWrapper
      isOnSale={determineIsOnSale(collection, priceZone)}
      data-testid={generateTestId('collection-tile', 'price-range')}
    >
      <PriceText>FROM</PriceText>
      <Price price={minPrice} />
      {minPrice !== maxPrice && (
        <>
          <PriceText>-</PriceText>
          <Price price={maxPrice} />
        </>
      )}
    </PriceRangeWrapper>
  )
}

export default PriceRange
